<!-- Barra de búsqueda -->
<div class="container-fluid mb-4">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      <div class="search-container position-relative">
        <input
          type="text"
          class="form-control form-control-lg search-input"
          placeholder="Buscar productos... (ej: Almohada, Colchón, Puff)"
          (focus)="mostrarResultados = true"
          (blur)="onSearchBlur()"
          [(ngModel)]="searchQuery"
          (input)="filtrarProductos()"
        />

        <!-- Resultados de búsqueda -->
        <div
          class="search-results dropdown-menu w-100 show"
          *ngIf="mostrarResultados && productosFiltrados.length > 0"
          (mouseenter)="onSearchMouseEnter()"
          (mouseleave)="onSearchMouseLeave()"
        >
          <div class="dropdown-header fw-bold text-primary">
            {{ searchQuery ? 'Productos encontrados' : 'Todos los productos' }}
            <span class="badge bg-secondary ms-2">{{ productosFiltrados.length }}</span>
          </div>
          <div *ngFor="let producto of productosFiltrados; let last = last">
            <a
              class="dropdown-item d-flex align-items-center py-3 search-result-item"
              (click)="scrollToProduct(producto.id)"
              (mousedown)="preventBlur($event)"
            >
              <img
                [src]="producto.mainImage"
                class="search-result-img me-3 rounded"
                alt="{{ producto.title }}"
              />
              <div class="flex-grow-1">
                <h6 class="mb-1 fw-semibold text-primary">{{ producto.title }}</h6>
                <p class="mb-0 text-muted small">{{ producto.description }}</p>
              </div>
              <i class="fas fa-arrow-right text-muted"></i>
            </a>
            <div class="dropdown-divider m-0" *ngIf="!last"></div>
          </div>
        </div>

        <!-- Mensaje cuando no hay resultados -->
        <div
          class="search-results dropdown-menu w-100 show"
          *ngIf="mostrarResultados && searchQuery && productosFiltrados.length === 0"
        >
          <div class="dropdown-item text-muted text-center py-4">
            <i class="fas fa-search fa-2x mb-2"></i>
            <p class="mb-0">No se encontraron productos para "{{ searchQuery }}"</p>
            <small>Intenta con "Almohada", "Colchón", "Puff", etc.</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Grid de productos -->
<div class="container-fluid py-4">
  <div class="row g-4">
    <div
      class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4"
      *ngFor="let producto of productos"
      [id]="'producto-' + producto.id"
    >
      <div class="card h-100 shadow-sm product-card">
        <!-- Título de la card -->
        <div class="card-header bg-transparent border-bottom-0 pb-0">
          <h5 class="card-title mb-0 fw-bold text-center">{{ producto.title }}</h5>
        </div>

        <!-- Contenedor principal de imágenes -->
        <div class="image-content-wrapper">
          <!-- Bloque de imágenes -->
          <div class="images-container">
            <!-- Imagen Principal - Click para abrir modal en móviles -->
            <div class="main-image-section" (click)="abrirModalImagen(producto.mainImage)">
              <img
                [src]="producto.mainImage"
                class="main-image"
                alt="Imagen principal {{ producto.title }}"
              />
            </div>

            <!-- Miniaturas con scroll -->
            <div class="thumbnails-section">
              <div class="thumbnails-scroll-container">
                <div class="thumbnails-grid">
                  <div
                    *ngFor="let thumb of producto.thumbnails; let i = index"
                    class="thumbnail-item"
                    (click)="cambiarImagenPrincipal(producto, thumb, $event)"
                  >
                    <img
                      [src]="thumb"
                      class="thumbnail-img"
                      [class.thumbnail-active]="thumb === producto.mainImage"
                      alt="Miniatura {{ producto.title }}"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Descripción y Botón -->
          <div class="content-section">
            <p class="product-description">{{ producto.description }}</p>
            <button class="btn btn-primary w-100 fw-semibold" (click)="contactar(producto.id)">
              <i class="fas fa-envelope me-2"></i>Cotizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal para imagen en pantalla completa en móviles -->
<div class="modal fade mobile-image-modal" id="mobileImageModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center p-0">
        <img
          [src]="selectedMobileImage"
          class="img-fluid w-100 mobile-full-image"
          alt="Imagen completa"
        />
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="mobile-thumbnails-container">
          <div
            *ngFor="let thumb of selectedProductThumbnails"
            class="mobile-thumbnail-item"
            (click)="changeMobileImage(thumb)"
          >
            <img
              [src]="thumb"
              class="mobile-thumbnail-img"
              [class.mobile-thumbnail-active]="thumb === selectedMobileImage"
              alt="Miniatura"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!---->
<div
  class="modal fade"
  id="imagenModal"
  tabindex="-1"
  aria-labelledby="imagenModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="imagenModalLabel">Vista previa</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Cerrar"
        ></button>
      </div>
      <div class="modal-body text-center">
        <img [src]="selectedImage" class="img-fluid rounded shadow" alt="Imagen ampliada" />
      </div>
    </div>
  </div>
</div>
